import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AppJSON from "./AppJSON";
import AppWrapper from "./AppWrapper";
import "./index.css";
import { ContextProvider } from "./TractumUI/engine/ContextEngine"; // 🚀 Import your provider
import { UserProvider } from "./context/UserContext";

// Render original app
const rootOld = ReactDOM.createRoot(document.getElementById("appRootOld"));
rootOld.render(
  <React.StrictMode>
    <UserProvider>
      <ContextProvider>
      <BrowserRouter>
        <AppWrapper>
          <App />
        </AppWrapper>
      </BrowserRouter>
      </ContextProvider>
    </UserProvider>
  </React.StrictMode>
);

// Render JSON dashboard
// const rootJSON = ReactDOM.createRoot(document.getElementById("appRootJSON"));
// rootJSON.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <AppWrapper>
//         <AppJSON />
//       </AppWrapper>
//     </BrowserRouter>
//   </React.StrictMode>
// );
